import { v4 } from "uuid";
import { Button } from "../../Atoms/Button";
import { Table } from "../../Molecules/Table";
import * as S from "./styles";
import dayjs from "dayjs";
import { useSettings } from "../../Templates/SettingsTemplate/useSettings";
import { useGoals } from "./useGoals";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { ISelectOptions } from "../../../types/inputs";
import { Pagination } from "../../Atoms/Pagination";

export const Goals = () => {
  const { canAccessGoals } = useSettings();
  const {
    isMobile,
    metas,
    openFilter,
    setOpenFilter,
    ANOS_OPTIONS,
    lojasOptions,
    filter,
    updateFilter,
    pagination,
    setNumberPage,
    handleFilter,
    navigate,
    MESES_OPTIONS,
  } = useGoals();

  return (
    <S.Container>
      <S.GoalsListWrapper>
        <h1>Metas Cadastradas</h1>

        {openFilter && (
          <S.Filter onSubmit={handleFilter}>
            <div>
              <SimpleSelect
                options={MESES_OPTIONS}
                label="Mês"
                onChange={(e: ISelectOptions) => updateFilter({ mes: e.value })}
                value={MESES_OPTIONS.find((e) => e.value === filter?.mes)}
              />
            </div>

            <div>
              <SimpleSelect
                options={ANOS_OPTIONS}
                label="Ano"
                onChange={(e: ISelectOptions) => updateFilter({ ano: e.value })}
                value={ANOS_OPTIONS.find((e) => e.value === filter?.ano)}
              />
            </div>

            <div>
              <SimpleSelect
                options={lojasOptions}
                label="Unidade"
                onChange={(e: ISelectOptions) =>
                  updateFilter({ uuidMunicipio: e.value })
                }
                value={lojasOptions.find(
                  (e) => e.value === filter?.uuidMunicipio
                )}
              />
            </div>

            <div>
              <Button
                onClick={() => setOpenFilter(false)}
                type="button"
                data-variant-underline
              >
                Limpar tudo
              </Button>
              <Button>Buscar</Button>
            </div>
          </S.Filter>
        )}

        <S.WrapperButtons>
          {!openFilter && (
            <Button data-variant-outline onClick={() => setOpenFilter(true)}>
              <img src="/assets/svgs/icon-filter-dark.svg" alt="icone filtro" />{" "}
              Filtro
            </Button>
          )}

          {canAccessGoals && (
            <Button
              data-variant-outline
              onClick={() => navigate(`/configuracoes/metas/cadastro`)}
            >
              <img src="/assets/svgs/icon-plus.svg" alt="icone +" /> Cadastrar
            </Button>
          )}
        </S.WrapperButtons>

        <Table.Root>
          <Table.WrapperItems>
            {metas?.map((i) =>
              isMobile ? (
                <S.ItemMobile key={v4()}>
                  <div id="wrapper-elements">
                    <S.TableElement>
                      Competência:
                      <span>{dayjs(i?.mes).format("MM/YYYY") || "---"}</span>
                    </S.TableElement>
                    <S.TableElement>
                      Unidade:
                      <span>{i?.municipio?.nome}</span>
                    </S.TableElement>
                    <S.TableElement>
                      QUANTIDADE:
                      <span>{i?.quantidadeTotal}</span>
                    </S.TableElement>
                  </div>
                  <div id="wrapper-icon">
                    <img
                      src="/assets/svgs/icon_edit_dark.svg"
                      alt="icone edicao"
                      onClick={() =>
                        navigate(`/configuracoes/metas/editar?uuid=${i.uuid}`)
                      }
                    />
                  </div>
                </S.ItemMobile>
              ) : (
                <Table.Item
                  key={v4()}
                  columns="1fr 1fr 1fr 1fr"
                  elements={[
                    <S.TableElement>
                      Competência:
                      <span>{dayjs(i?.mes).format("MM/YYYY") || "---"}</span>
                    </S.TableElement>,
                    <S.TableElement>
                      Unidade:
                      <span>{i?.municipio?.nome}</span>
                    </S.TableElement>,
                    <S.TableElement>
                      QUANTIDADE:
                      <span>{i.quantidadeTotal}</span>
                    </S.TableElement>,
                  ]}
                  lastElement={
                    <img
                      src="/assets/svgs/icon_edit_dark.svg"
                      alt="icone edicao"
                      onClick={() =>
                        navigate(`/configuracoes/metas/editar?uuid=${i.uuid}`)
                      }
                    />
                  }
                />
              )
            )}
          </Table.WrapperItems>
        </Table.Root>

        {metas?.length > 0 && (
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination?.totalPage}
            totalRegister={pagination?.totalPage}
            actualPage={pagination?.actualPage}
            setNumberPage={setNumberPage}
          />
        )}

        <S.WrapperActions>
          <Button data-variant-underline onClick={() => navigate(-1)}>
            Voltar
          </Button>
        </S.WrapperActions>
      </S.GoalsListWrapper>
    </S.Container>
  );
};
